import { render, staticRenderFns } from "./InvoiceDocuments.vue?vue&type=template&id=467f46f4&"
import script from "./InvoiceDocuments.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDocuments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports